<template>
<div class="chapter">
<div class="inner_page">
<div aria-label="38" epub:type="pagebreak" id="page38" role="doc-pagebreak">
</div>
<div class="Basic-Text-Frame" id="_idContainer016">
<p class="chapter-number-only" id="_idParaDest-5">5</p>
<p class="text-flush-left">“You okay?”</p>
<p class="text-indented">Amy turned to face Bobby, her hands still moving, massaging the dough. “Huh? I’m fine. Why?”</p>
<p class="text-indented">“You’re working about twice normal speed. And you’re singing.”</p>
<p class="text-indented">“What? I’m not singing, Bobby.”</p>
<p class="text-indented">“Humming. Whatever. You never hum. You’re always … you know.”</p>
<p class="text-indented">Amy’s hands stilled. “I’m always <span class="Italic-Style">what</span>?”</p>
<p class="text-indented">Bobby looked at her a long moment, then turned his attention to the oven on his left. “Nothing. Forget it.”</p>
<p class="text-indented">Amy tossed the dough onto the counter and rubbed the flour from her hands as she advanced on Bobby. “No, it’s not nothing. What did you mean?”</p>
<p class="text-indented">He shrugged. “Well … like there’s a black cloud hanging over you.” He pulled open the oven door. “You’re kind of, I dunno, depressed.”</p>
<p class="text-indented">Amy frowned. “There’s more to it than that.” She headed back to her workstation. “And I wasn’t humming.”</p>
<p class="text-indented">“That song from<span class="Italic-Style"> Something Rotten</span>.”</p>
<p class="text-indented">Amy had to fight to keep herself from smiling.</p>
<div aria-label="39" epub:type="pagebreak" id="page39" role="doc-pagebreak">
</div>
<p class="text-indented">“Yeah, I see that grin. I’m right, aren’t I?”</p>
<p class="text-indented">“Yes.”</p>
<p class="text-indented">Bobby laughed boisterously. “So … what, did you meet someone?”</p>
<p class="text-indented"><span class="Italic-Style">I did, but it’s not what you’re thinking. </span>“No.”</p>
<p class="text-indented">“But something happened at lunch. You were real quiet this morning, you leave for a half hour and you’re humming Broadway tunes.”</p>
<p class="text-indented">Amy punched her fist into the mound—one of the things she enjoyed about her job. Controlled aggression. “Whatever.”</p>
<p class="text-indented">“Yeah,” Bobby said with another laugh. “Whatever. But whoever it is, I’m happy for you. Even if I wanted it to be me. I’m happy for you.”</p>
<p class="text-indented">“I didn’t meet a guy.”</p>
<p class="text-indented">“Hmm. Then I still got a chance.”</p>
<p class="text-indented-space-after">“You know, Bobby, that’s true. You do. Just like winning the lottery.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504095785-5.vue?906e2692